import { Box, Typography } from '@mui/material'
import MuxPlayer from '@mux/mux-player-react'
import { ReactElement, useState } from 'react'
import { VideoLibraryItem } from '../../course/types'
import LibraryCardBase from '../../shared/components/library-card-base'

type VideoCardProps = {
  video: VideoLibraryItem
  onEdit: () => void
  onDelete: () => void
  onMigrate: () => void
}

export default function VideoCard({
  video,
  onEdit,
  onDelete,
  onMigrate,
}: VideoCardProps): ReactElement {
  let src = video.fileName ? video.fileName.replace('mp4', 'm3u8') : undefined
  let [videoError, setVideoError] = useState(false)

  let mediaContent =
    src && !videoError ? (
      <Box sx={{ paddingTop: '56.25%' }} className="relative">
        <MuxPlayer
          src={src}
          title={video.name}
          accentColor="#f9ea4f"
          primaryColor="#6694E9"
          className="absolute top-0 left-0 w-full h-full"
          onError={() => setVideoError(true)}
        />
      </Box>
    ) : (
      <Box sx={{ paddingTop: '56.25%' }} className="relative">
        <Box
          className="absolute inset-0 flex items-center justify-center p-4"
          sx={{ bgcolor: 'background.paperDark' }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            className="text-center"
          >
            Video is still processing. Please try again later.
          </Typography>
        </Box>
      </Box>
    )

  return (
    <LibraryCardBase
      name={video.name}
      description={video.description}
      courses={video.courses}
      isMigratable={video.isMigratable}
      onEdit={onEdit}
      onDelete={onDelete}
      onMigrate={onMigrate}
      itemLabel="video"
      mediaContent={mediaContent}
    />
  )
}
